var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1303_134769)" } }, [
        _c("path", {
          attrs: {
            d: "M9.03041 -2C9.70289 -2 10.2462 -1.4567 10.2462 -0.784224V0.572127C10.307 0.579726 10.364 0.587324 10.4248 0.598722C10.44 0.602521 10.4514 0.602521 10.4665 0.606321L12.2902 0.940659C12.9513 1.06224 13.3882 1.69672 13.2666 2.354C13.1451 3.01128 12.5106 3.452 11.8533 3.33042L10.0486 2.99988C8.85944 2.82511 7.81084 2.94289 7.07377 3.23544C6.33671 3.52798 6.04036 3.93071 5.97198 4.30304C5.89599 4.70957 5.95298 4.93752 6.01757 5.0781C6.08595 5.22627 6.22653 5.39344 6.50388 5.57961C7.12316 5.98613 8.07299 6.25208 9.30396 6.57882L9.41414 6.60922C10.5007 6.89796 11.8305 7.2475 12.8183 7.89338C13.3578 8.24672 13.8669 8.72543 14.1823 9.3941C14.5052 10.0742 14.5736 10.834 14.4254 11.6433C14.1633 13.087 13.1679 14.052 11.9331 14.5574C11.4126 14.7701 10.8465 14.9069 10.2462 14.9753V16.2366C10.2462 16.9091 9.70289 17.4524 9.03041 17.4524C8.35794 17.4524 7.81464 16.9091 7.81464 16.2366V14.9107C7.79944 14.9069 7.78044 14.9069 7.76525 14.9031H7.75765C6.83062 14.7587 5.3071 14.3598 4.28129 13.9039C3.6696 13.6303 3.39225 12.9123 3.6658 12.3006C3.93935 11.6889 4.65742 11.4115 5.2691 11.6851C6.06316 12.0384 7.37012 12.388 8.12618 12.5057C9.33816 12.6843 10.3374 12.5817 11.0136 12.3044C11.6557 12.0422 11.9483 11.6623 12.0319 11.2064C12.104 10.8036 12.0471 10.5719 11.9825 10.4313C11.9103 10.2793 11.7697 10.1122 11.4886 9.92601C10.8655 9.51948 9.91185 9.25353 8.67708 8.92679L8.5707 8.9002C7.4879 8.61145 6.15814 8.25811 5.17032 7.61223C4.63082 7.2589 4.12551 6.77639 3.81017 6.10771C3.49103 5.42763 3.42644 4.66777 3.57842 3.85852C3.85197 2.40719 4.93857 1.46496 6.17334 0.974853C6.67865 0.77349 7.23334 0.636715 7.81464 0.55693V-0.784224C7.81464 -1.4567 8.35794 -2 9.03041 -2Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1303_134769" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0.5)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }